import { JSONSchemaType } from 'ajv'

export interface IMenuOptionFormData {
  moduleId: string
  sequence: string
  label: string
  route: string
  icon: string
  key: string
  disabled: boolean
}

const MenuOptionSchema: JSONSchemaType<IMenuOptionFormData> = {
  type: 'object',
  properties: {
    moduleId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    sequence: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    label: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    route: {
      type: 'string',
    },
    icon: {
      type: 'string',
    },
    key: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['moduleId', 'sequence', 'label'],
  additionalProperties: false,
}

export default MenuOptionSchema
